<template>
  <div class="components-dialog">
    <a-modal
      :title="form.id ? (form.disabled ? '查看' : $t('update')) : $t('create')"
      :visible="dialog"
      :maskClosable="false"
      @cancel="cancel"
    >
      <template slot="footer">
        <a-button key="back" @click="cancel"> 取消 </a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="confirm"
        >
          提交
        </a-button>
      </template>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 20 }"
      >
        <a-form-model-item label="分类" prop="category">
          <a-radio-group v-model="form.category" :disabled="form.disabled">
            <a-radio
              v-for="(i, index) in dictList"
              :key="index"
              :value="i.dictKey"
              >{{ i.dictValue }}</a-radio
            >
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="资源编号" prop="ossCode">
          <a-input
            :disabled="form.disabled"
            v-model="form.ossCode"
            placeholder="请输入资源编号"
            :maxLength="maxLength"
          />
        </a-form-model-item>
        <a-form-model-item label="资源地址" prop="endpoint">
          <a-input
            :disabled="form.disabled"
            v-model="form.endpoint"
            placeholder="请输入资源地址"
            :maxLength="maxLength"
          />
        </a-form-model-item>
        <a-form-model-item label="空间名" prop="bucketName">
          <a-input
            :disabled="form.disabled"
            v-model="form.bucketName"
            placeholder="请输入空间名"
            :maxLength="maxLength"
          />
        </a-form-model-item>
        <a-form-model-item label="accessKey" prop="accessKey">
          <a-input
            :disabled="form.disabled"
            v-model="form.accessKey"
            placeholder="请输入accessKey"
            :maxLength="maxLength"
          />
        </a-form-model-item>
        <a-form-model-item label="secretKey" prop="secretKey">
          <a-input
            :disabled="form.disabled"
            v-model="form.secretKey"
            placeholder="请输入secretKey"
            :maxLength="maxLength"
          />
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-input
            :disabled="form.disabled"
            v-model="form.remark"
            placeholder="请输入备注"
            :maxLength="maxLength"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { ossSubmit } from "../api";
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    form: Object,
    dictList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      rules: {
        category: [{ required: true, message: "分类必选", trigger: "change" }],
        ossCode: [{ required: true, message: "资源编号必填", trigger: "blur" }],
        endpoint: [
          { required: true, message: "资源地址必填", trigger: "blur" },
        ],
        bucketName: [
          { required: true, message: "空间名必填", trigger: "blur" },
        ],
        accessKey: [
          { required: true, message: "accessKey必填", trigger: "blur" },
        ],
        secretKey: [
          { required: true, message: "secretKey必填", trigger: "blur" },
        ],
      },
      maxLength: 30,
      loading: false,
    };
  },
  methods: {
    cancel() {
      this.$refs.ruleForm.clearValidate();
      this.$emit("close");
    },
    confirm() {
      if (this.loading) {
        return;
      }
      if (this.form.disabled) {
        return this.$emit("close");
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          ossSubmit(this.form).then(res=>{
            this.$emit("update");
            this.loading = false;
          }).catch(_=>{
            this.loading = false;
          })
        }
      });
    },
  },
};
</script>